var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFinmoLogo = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 3.75v10.5a.75.75 0 0 1-.75.75H15v5.25a.75.75 0 0 1-.75.75H3.75a.75.75 0 0 1-.75-.75V9.75A.754.754 0 0 1 3.75 9H9V3.75A.754.754 0 0 1 9.75 3h10.5a.75.75 0 0 1 .75.75Z",
  opacity: 0.6
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.25 9H9v5.25c0 .414.336.75.75.75H15V9.75a.75.75 0 0 0-.75-.75Z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFinmoLogo);
export default ForwardRef;